// extracted by mini-css-extract-plugin
export default {"spoiler":"Spoiler_spoiler__Ew3ZD","active":"Spoiler_active__Vndwg","spoilerContent":"Spoiler_spoilerContent__jF2XH","spoilerTitle":"Spoiler_spoilerTitle__ysnsz"};